<p-confirmDialog key="modify" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid2Col">
	<!--INSERT CUSTOM POPUP FIELDS-->
	<label>Code:</label>
	<input
		[disabled]="Imported == true"
		class="form-control"
		type="text"
		placeholder="20 Charcter Route Type Code/Abbreviation"
		[(ngModel)]="BusRouteTypeNbr"
	/>

	<label>Description:</label>
	<input class="form-control" type="text" placeholder="Route Type Name/Description" [(ngModel)]="BusRouteTypeDesc" />
</div>

<!--Buttons-->
<div class="Buttons">
	<button *ngIf="EditMode == false" [disabled]="Imported == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button *ngIf="EditMode == true" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
